<template>
  <main id="contents" class="category">
    <MainCategoryHeader
      v-if="hasSubCategoryFilter"
      :title="mainTitle"
      :options="subCategoryList.itemList"
      :default="'장르'"
      :value="mainCode"
    />

    <div class="container">
      <WCatalog v-if="catalogData" :id="id" :catalog="catalogData" />
    </div>
  </main>
</template>

<script setup>
  import { ref, computed, watch, reactive } from 'vue'
  import { useRoute } from 'vue-router/composables'
  import { useStore } from '@/common/utils/store'
  import { scrollTop, titleTagNameChange } from '@/common/utils/common'
  import WCatalog from '@/pages/home/WCatalog'
  import MainCategoryHeader from '@/components/category/Main/Header'
  import { convertEventOnClick } from '@/common/converter/convert-event-on-click'
  import { getCategoryMainHomeData } from '@/common/requests/data-fetch/get-category-main-home-data'

  const route = useRoute()
  const store = useStore()

  const catalogData = ref({})
  const categoryData = ref({})
  const id = ref('')
  const mainTitle = ref('')
  const subList = ref(null)
  const subCategoryList = reactive({
    _default: '',
    itemList: [],
  })

  const titleTagName = computed(() => `${mainTitle.value} : 웨이브 카테고리`)
  const mainCode = computed(() => route?.query.mainCode?.toUpperCase() ?? '')
  const hasSubCategoryFilter = computed(
    () => (subCategoryList.itemList.length ?? 0) > 0,
  )

  watch(route, ({ query }) => {
    if (query.mainCode) {
      init()
    }
  })

  const setFilterValues = () => {
    if (!subList.value) return

    subCategoryList._default = subList.value[0]?.title ?? ''
    subCategoryList.itemList = [...subList.value]
  }

  const setInitialFilter = (category) => {
    const current = category.categoryList?.find(
      (cate) => cate.code === mainCode.value,
    )

    if (!current) return

    mainTitle.value = current?.elementList[0]?.property?.text ?? ''
    subList.value = current?.subList.map((sub) => {
      return {
        adult: 'n',
        title: sub.elementList[0].property.text,
        value: sub.code,
        eventlist: [convertEventOnClick(sub.elementList)],
      }
    })
    subList.value?.unshift({
      adult: 'n',
      hideValue: true,
      title: `${mainTitle.value} 홈`,
      value: mainCode.value,
      callback: () => {
        location.reload()
      },
    })
  }

  const setCategoryMain = async () => {
    const { data } = await getCategoryMainHomeData({ category: mainCode.value })

    if (data) {
      const { catalog, category } = data?.layout
      catalogData.value = catalog ?? {}
      categoryData.value = category ?? {}
      id.value = data?.id ?? ''
      store.commit('setCategory', { category })
    }
  }

  const init = async () => {
    scrollTop()
    await setCategoryMain()
    setInitialFilter(categoryData.value)
    setFilterValues()
    titleTagNameChange(titleTagName.value)
  }

  init()
</script>

<style lang="scss" scoped>
  .category {
    .container {
      margin-top: 40px;
    }
  }
</style>
